import { render, staticRenderFns } from "./TableServicesOrderAdmin.vue?vue&type=template&id=5843c102"
import script from "./TableServicesOrderAdmin.vue?vue&type=script&lang=js"
export * from "./TableServicesOrderAdmin.vue?vue&type=script&lang=js"
import style0 from "./TableServicesOrderAdmin.vue?vue&type=style&index=0&id=5843c102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports